export default __webpack_public_path__ + "static/media/Path 733.752fceb2.svg";